export default "__VITE_ASSET__Do9jOIUv__"